export default {
    getAllUsers: () => {
        return {
            url: '/fhepool/users',
            method: 'GET'
        };
    },
    getUserDetails: userId => {
        return {
            url: '/fhepool/users/:userId',
            method: 'GET',
            route_params: {
                userId
            }
        };
    },
    updateUserDetails: (userId, userForm) => {
        return {
            url: '/fhepool/users/:userId',
            method: 'PATCH',
            route_params: {
                userId
            },
            patch_params: {
                email: userForm.email,
                lastname: userForm.lastname,
                firstname: userForm.firstname,
                emailGoogle: userForm.emailGoogle,
                emailFacebook: userForm.emailFacebook,
                city: userForm.city,
                address: userForm.address,
                postalCode: userForm.postalCode,
                telFixe: userForm.telFixe,
                telPort: userForm.telPort,
                weatherCity: userForm.weatherCity
            }
        };
    },
    addUser: userForm => {
        let params = {};
        Object.keys(userForm).map(field => {
            if (userForm[field]) params[field] = userForm[field];
        });
        return {
            url: '/fhepool/addUser',
            method: 'POST',
            patch_params: params
        };
    },
    resetPassword: userId => {
        return {
            url: '/fhepool/users/:userId/resetPassword',
            method: 'PATCH',
            route_params: {
                userId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/Users/api.js